.notes-input {
  width: 100%;
  padding: 0.8rem;
  font-size: 1.2rem;
  color: var(--color-grayscale-white);
  position: relative;
  box-sizing: border-box;
  font-family: Inter, sans-serif;
  resize: none;
  background-color: transparent;

  p {
    font-size: 1.4rem;
    line-height: 1.8rem;
  }

  &::placeholder {
    font-size: 1.2rem;
    color: var(--color-grayscale-light-slate);
  }

  &:hover {
    background-color: var(--color-grayscale-arsenic);
    cursor: text;
  }

  &:focus {
    background-color: transparent !important;
    border-color: var(--color-grayscale-trout);
  }

  &[data-error='true'] {
    &:focus {
      border-color: var(--color-error);
    }
  }
}
